import { Effect, /* ImmerReducer, */ Reducer, Subscription } from 'umi';
import { getLeftMenuList } from '@gp/services/global';
import { MenuResultType } from '@gp/types/global';

export const LEFT_MENU_NAMESPACE = 'gpopLeftMenu';
const getAuthSet = (menuList: any) => {
  const tempSet = new Set<string>();
  if (!menuList) return tempSet;
  const getMenuKey = (list: MenuResultType[]) => {
    list.forEach(({ sub_menus, page_id }) => {
      tempSet.add(page_id);
      if (Array.isArray(sub_menus)) {
        getMenuKey(sub_menus);
      }
    });
  };
  getMenuKey(menuList);
  return tempSet;
};

export interface GPOPLeftMenuModelState {
  authSet: Set<string>;
  menuList: any;
  isFoldMenu: boolean;
  isReady: boolean;
}

export interface GPOPLeftMenuModelType {
  namespace: string;
  state: GPOPLeftMenuModelState;
  effects: {
    query: Effect;
    setIsFoldMenu: Effect;
  };
  reducers: {
    save: Reducer<GPOPLeftMenuModelState>;
    // 启用 immer 之后
    // save: ImmerReducer<GPOPLeftMenuModelState>;
  };
  subscriptions?: { setup: Subscription };
}

const GPOPLeftMenuModel: GPOPLeftMenuModelType = {
  namespace: LEFT_MENU_NAMESPACE,

  state: {
    authSet: new Set(),
    menuList: null,
    isFoldMenu: false,
    isReady: false,
  },

  effects: {
    *query({ payload }, { call, put, select }) {
      // @ts-ignore
      // const state = yield select((state: any) => state);
      // if (state?.loading?.effects?.[`${LEFT_MENU_NAMESPACE}/query`] || state?.[LEFT_MENU_NAMESPACE]?.isReady) return;
      // @ts-ignore
      const menuList: any = yield getLeftMenuList();
      yield put({
        type: 'save',
        payload: {
          authSet: getAuthSet(menuList),
          menuList,
          isReady: true,
        },
      });
    },
    *setIsFoldMenu({ payload }, { call, put }) {
      yield put({
        type: 'save',
        payload: {
          isFoldMenu: payload?.isFoldMenu,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    // 启用 immer 之后
    // save(state, action) {
    //   state.name = action.payload;
    // },
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {});
    },
  },
};

export default GPOPLeftMenuModel;
